// import store from '../../store';
import axios from 'axios';
import * as ShipConstants from '../../Global/Constants';
import { decryptAES, isSet } from '../../Utils/CommonFunctions';
import { IsEncrypted } from '../../envConfig';
// import {failMessage} from '../../store/actions/CommonActions';


// import {removeAuthentication} from '../../Store/actions/Auth';

const configAxios = axios.create({
    baseURL:  ShipConstants.API_URL,
});

const requestHandler = request => {
    // Auth Token  
    const accessToken = localStorage.getItem('access_token');
    request.params = {
        access_token: accessToken
    }
    let customHeaders = {};
    if(IsEncrypted===true){
        customHeaders = {
            'X-Encrypted-Data':'dHJ1ZQ=='
        }
    }
    // console.log('request.headers',request.headers);
    request.headers  = {
        ...customHeaders,
		...request.headers
		// 'X-Encrypted-Data':btoa(IsEncrypted),
	}
    // const data = decryptAES();
	// console.log('decryptAES',data);
    // console.log('request',request);
    return request;
};

const responseHandler = response => {
    const {config} = response;
    let isEnc = false;
    try{
        isEnc = (isSet(config.headers['X-Encrypted-Data'],null)!==null)?true:false;
    }catch(e){

    }

    
    if (response.status === 401) {
        // window.location = '/login';
    }
    // console.log('response',isEnc);
    try{
		let returnResponse = {...response};
        // console.log('returnResponse',returnResponse);
		if(isSet(response.status,response.statusCode)===200){
			const resData = response.data;
			returnResponse ={
				...returnResponse,
				data:{
					...resData,
					data:isEnc===true?decryptAES(resData.data):resData.data,
				}
			}
			// console.log('returnRes',returnResponse.data);
		}
        return returnResponse;
	}catch(e){
		return null;
	}
    // console.log('responseHandler',response);
    // return response;
};

//Request Error Handler
const requestErrorHandler = error => {
    return Promise.reject(error);
};

//Response Error Handler
const responseErrorHandler = error => {
    // handle the response error
    // console.log('reserror',error);
    /*1021 - Issue fix --start */
    try{
        if(error.response && error.response.data.error==="invalid_token"){
            // const {dispatch} = store;
            // console.log('invalid token');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('user');
            localStorage.removeItem('moduleId');
            // dispatch(failMessage(error.response.data.message));
            document.location.href ='/login';
        }
        else if(error.response && (error.response.status===403)){
            console.log(error.response);
            // const {dispatch} = store;
            // dispatch(failMessage(error.response.data.message));
            //For checking session is expired or not and redirect to login page.
            
        }
    }catch(e){

    }
    // try{
    //     if (error.response.data.error === "invalid_token") {
    //         const { dispatch } = store;
    //         // dispatch(removeAuthentication());
    //     } else if (error.response && (error.response.status === 403)) {
    //         console.log('res1error', error,error.response);
    //         //For checking session is expired or not and redirect to login page.
    //     }
    // }catch(e){

    // }
    if(error.response !== undefined){
        return Promise.reject(error.response);
    }else{
        return Promise.reject(error);
    }
        /*1021 - Issue fix --end */

};


configAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => requestErrorHandler(error)
);

configAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => responseErrorHandler(error)
);

export default configAxios;